export const getUpdateSingleItem = async (item, itemId) => {
  const singleUpdateItem = await item.find((data) => {
    return data.id === itemId;
  });
  return singleUpdateItem;
};
